import React from 'react'
import PropTypes from 'prop-types'
import CharacterCard from './CharacterCard'
import EmptySlotCard from './EmptySlotCard'
import './Characters.styles.css'

export default function CharacterGrid({ items, emptySlotsCount, onCreateClick, onCardClick, onToggleMain }) {
  const empties = Math.max(0, Number(emptySlotsCount || 0))

  return (
    <div className="charactersGrid" role="grid" aria-label="Cuadrícula de ninjas y slots libres">
      {items.map((c) => (
        <CharacterCard
          key={c.id}
          id={c.id}
          slug={c.slug}
          name={c.name}
          clan={c.clan}
          rank={c.rank}
          level={c.level}
          main={!!c.main}
          imageUrl={c.imageUrl}
          onToggleMain={onToggleMain}
          onClick={() => onCardClick(c.slug)}
        />
      ))}

      {Array.from({ length: empties }).map((_, i) => (
        <EmptySlotCard key={`empty-${i}`} onClick={onCreateClick} />
      ))}
    </div>
  )
}

CharacterGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      clan: PropTypes.string,
      rank: PropTypes.string,
      level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      main: PropTypes.bool,
      imageUrl: PropTypes.string.isRequired,
    })
  ).isRequired,
  emptySlotsCount: PropTypes.number.isRequired,
  onCreateClick: PropTypes.func.isRequired,
  onCardClick: PropTypes.func.isRequired,
  onToggleMain: PropTypes.func.isRequired,
}
